import React from 'react';

import {Provider} from "react-redux";

import ImageListContainer from "./container/ImageListContainer";

import configure from '../../../store/configure';
import Layout from "../../../component/layout/Layout";

const SelfMessageImageListPage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <ImageListContainer/>
            </Layout>
        </Provider>
    );
};


export default SelfMessageImageListPage;
